import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontAngkor, fontFredoka, theme, transientOptions } from "@product/scmp-sdk";

import { BaseImage } from "scmp-app/components/common/base-image";

import ImgPiggledy from "./img-piggledy.png";
import { NewsletterWidget } from "./newsletter-widget";

export const Container = styled.div`
  scroll-margin-top: 66px;
  ${theme.breakpoints.up("desktop")} {
    scroll-margin-top: 100px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding-block-end: 6px;
  padding-inline: 24px;

  background-color: #0f75bf;

  ${theme.breakpoints.up("tablet")} {
    padding-inline: 104px;
  }

  ${theme.breakpoints.up("desktop")} {
    flex-direction: row;
    align-items: flex-end;

    padding-inline: 112px;
  }

  ${theme.breakpoints.up("largeDesktop")} {
    padding-inline: 149px;
  }
`;

export const Header = styled.div`
  margin-block-end: 12px;

  color: #fecc17;
  font-weight: 400;
  font-size: 36px;
  font-family: ${fontAngkor};
  line-height: 40px;
  letter-spacing: -0.04em;

  ${theme.breakpoints.up("desktop")} {
    font-size: 48px;
    line-height: 58px;
  }
`;
export const Description = styled.div`
  margin-block-end: 24px;

  color: #ffffff;
  font-weight: 400;
  font-size: 16px;
  font-family: ${fontFredoka};
  line-height: 22px;

  ${theme.breakpoints.up("desktop")} {
    margin-block-end: 40px;

    font-size: 24px;
    line-height: 31px;
  }
`;

export const ContentContainer = styled.div`
  flex: 1;
  align-self: flex-start;

  margin-block-end: 60px;

  ${theme.breakpoints.up("desktop")} {
    flex: 0 0 547px;

    margin-block-end: 0;
  }

  ${theme.breakpoints.up("mediumDesktop")} {
    flex: 0 0 792px;
  }
`;

export const ImageContainer = styled.div`
  inline-size: 300px;
  block-size: auto;
  max-inline-size: ${ImgPiggledy.width}px;
  max-block-size: ${ImgPiggledy.height}px;

  ${theme.breakpoints.up("desktop")} {
    inline-size: 100%;
  }
`;

export const StyledImagePiggledy = styled(BaseImage)``;

type NewsletterWidgetProps = {
  $isHidden: boolean;
};
export const StyledNewsletterWidget = styled(NewsletterWidget, {
  ...transientOptions,
})<NewsletterWidgetProps>`
  ${props =>
    props.$isHidden &&
    css`
      visibility: hidden;
    `}
`;
